import * as classNames from 'classnames';
import * as React from 'react';

import {
    statusBar     as cssStatusBar,
    container     as cssContainer,
    peer          as cssPeer,
    grey          as cssGrey,
    yellow        as cssYellow,
    green         as cssGreen,
    legend        as cssLegend,
    legendContent as cssLegendContent,
    legendButton  as cssLegendButton,
    legendItem    as cssLegendItem,
    icon          as cssIcon,
    button        as cssButton,
} from './status-bar.module.sass';

export type StatusColor = 'grey' | 'yellow' | 'green';

export interface IVideoStatusBarProps {
    selfColor: StatusColor;
    peerColor: StatusColor;
    isSendingScreen: boolean;
    sendScreen?: () => void;
}

export const VideoStatusBar: React.StatelessComponent<IVideoStatusBarProps> = ({
    selfColor,
    peerColor,
    isSendingScreen,
    sendScreen,
}: IVideoStatusBarProps) => (
    <div className={cssStatusBar}>
        <div className={cssContainer}>
            <div className={cssPeer}>
                <span className={classNames({
                    [cssGrey]:   selfColor === 'grey',
                    [cssYellow]: selfColor === 'yellow',
                    [cssGreen]:  selfColor === 'green',
                })} />
                You
            </div>
            <div className={cssPeer}>
                <span className={classNames({
                    [cssGrey]:   peerColor === 'grey',
                    [cssYellow]: peerColor === 'yellow',
                    [cssGreen]:  peerColor === 'green',
                })} />
                Peer
            </div>
        </div>
        {false /* Turned off for white label. */ && sendScreen ? (
            <button className={cssButton} onClick={sendScreen} disabled={isSendingScreen}>
                <i className={`${cssIcon} fa fa-desktop`} aria-hidden='true' />
                {isSendingScreen ? 'Sharing screen' : 'Share screen'}
            </button>
        ) : (
            <div className={cssLegend}>
                <div className={cssLegendButton}>
                    <i className={`${cssIcon} fa fa-bars`} aria-hidden='true' />
                    <span>Legend</span>
                </div>
                <div className={cssLegendContent}>
                    <span className={cssLegendItem}><span className={cssGreen} /> Online</span>
                    <span className={cssLegendItem}><span className={cssYellow} /> Connecting</span>
                    <span className={cssLegendItem}><span className={cssGrey} /> Offline</span>
                </div>
            </div>
        )}
    </div>
);
